import { Check } from 'lucide-react'
import './Checkbox.css'

export default function Checkbox({ id, checked, onChange, disabled = false, children }) {
  return (
    <label className={`checkbox${disabled ? ' checkbox--disabled' : ''}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="checkbox__input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span className="checkbox__box" aria-hidden="true">
        <Check size={13} strokeWidth={3.5} />
      </span>
      <span className="checkbox__label">{children}</span>
    </label>
  )
}
